import React from 'react';

const EstatePage: React.FC = () => {
  return (
    <div style={{ paddingTop: '70px', minHeight: '100vh', padding: '120px 20px 80px' }}>
      <div style={{ maxWidth: '800px', margin: '0 auto', textAlign: 'center' }}>
        <h1 style={{ fontSize: '2.5rem', marginBottom: '20px', color: '#000' }}>
          New Wave Estate & Properties Development Limited
        </h1>
        <p style={{ fontSize: '1.2rem', color: '#666', lineHeight: '1.6', marginBottom: '40px' }}>
          Creating premium real estate solutions and property development projects 
          that transform communities. We specialize in innovative property development 
          and strategic real estate investments across Nigeria.
        </p>
        
        <div style={{ marginTop: '40px', textAlign: 'left', maxWidth: '600px', margin: '40px auto 0' }}>
          <h3 style={{ color: '#000', marginBottom: '20px', textAlign: 'center' }}>Our Services:</h3>
          
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '20px' }}>
            <div style={{ background: '#f8f9fa', padding: '20px', borderRadius: '8px' }}>
              <h4 style={{ color: '#000', marginBottom: '10px' }}>Property Development</h4>
              <p style={{ color: '#666', fontSize: '0.9rem' }}>Comprehensive residential and commercial property development</p>
            </div>
            
            <div style={{ background: '#f8f9fa', padding: '20px', borderRadius: '8px' }}>
              <h4 style={{ color: '#000', marginBottom: '10px' }}>Real Estate Investment</h4>
              <p style={{ color: '#666', fontSize: '0.9rem' }}>Strategic investment opportunities in prime real estate markets</p>
            </div>
            
            <div style={{ background: '#f8f9fa', padding: '20px', borderRadius: '8px' }}>
              <h4 style={{ color: '#000', marginBottom: '10px' }}>Urban Planning</h4>
              <p style={{ color: '#666', fontSize: '0.9rem' }}>Innovative urban planning and community development solutions</p>
            </div>
            
            <div style={{ background: '#f8f9fa', padding: '20px', borderRadius: '8px' }}>
              <h4 style={{ color: '#000', marginBottom: '10px' }}>Property Management</h4>
              <p style={{ color: '#666', fontSize: '0.9rem' }}>Professional property management and maintenance services</p>
            </div>
          </div>
        </div>
        
        <div style={{ marginTop: '60px' }}>
          <a 
            href="/#contact" 
            style={{ 
              background: '#000', 
              color: '#fff', 
              padding: '12px 24px', 
              borderRadius: '8px', 
              textDecoration: 'none',
              fontSize: '1rem',
              fontWeight: '500'
            }}
          >
            Get In Touch
          </a>
        </div>
      </div>
    </div>
  );
};

export default EstatePage;
